<template>
  <v-dialog
    v-model="isDialogOpen"
    :max-width="width"
    :scrollable="true"
    :content-class="isMobileOrTablet ? 'rounded' : 'rounded-r-xl'"
    :persistent="persistent"
  >
    <v-card color="white" :height="height">
      <!-- It must be inside a v-card-text or scroll overflow will have transparent background -->
      <v-card-text class="pa-0 text-black">
        <v-row no-gutters :class="{ 'fill-height': !isMobileOrTablet }">
          <v-col cols="12" md="3" class="elevation-1 bg-main-color">
            <v-row no-gutters class="fill-height" align="center">
              <p class="text-white left-side-text ma-0 py-2">
                {{ title }}
              </p>
            </v-row>
          </v-col>
          <v-col
            cols="12"
            md="9"
            class="pa-2 pa-md-5 height-100-col overflow-y-auto"
          >
            <div class="d-flex flex-column align-center">
              <iusa-logo no-link />
              <div class="mt-5 border pa-2 rounded-lg w-100">
                <icon-title
                  :text="subtitle"
                  :icon="icon"
                  :icon-class="icon ? 'mr-2' : ''"
                  title-class="text-h6 text-md-h6"
                />
                <p class="mb-0">
                  {{ caption }}
                </p>
                <slot />
              </div>
            </div>

            <div class="d-flex align-center justify-end gap-1 mt-2 mt-md-5">
              <slot name="actions" />
              <v-btn
                v-if="!hideCloseButton"
                :class="closeButtonClass"
                width="auto"
                @click="closeModal"
              >
                {{ closeButtonText }}
              </v-btn>
              <slot name="actions-append" />
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import screen from '@/mixins/screen';
  import IusaLogo from '../IusaLogo.vue';
  import IconTitle from '../IconTitle.vue';

  export default {
    name: 'TwoSidesModal',

    components: { IusaLogo, IconTitle },

    mixins: [screen],

    props: {
      value: {
        type: Boolean,
        required: true,
      },

      title: {
        type: String,
        required: true,
      },

      caption: {
        type: String,
        default: '',
      },

      icon: {
        type: String,
        default: '',
      },

      subtitle: {
        type: String,
        default: '',
      },

      hideLogo: Boolean,

      closeButtonText: {
        type: String,
        default: 'Cerrar',
      },

      height: {
        type: [String, Number],
        default: '550px',
      },

      width: {
        type: [String, Number],
        default: '1050px',
      },

      persistent: Boolean,
      hideCloseButton: Boolean,
      closeButtonClass: {
        type: String,
        default: 'red-button',
      },
    },

    computed: {
      isDialogOpen: {
        get() {
          return this.value;
        },
        set(value) {
          this.$emit('input', value);
        },
      },
    },

    methods: {
      closeModal() {
        this.$emit('onClose');
        this.isDialogOpen = false;
      },
    },
  };
</script>

<style>
  .left-side-text {
    font-weight: bolder;
    min-height: 50px;
  }

  .left-side-text::after {
    display: block;
    width: auto;
    content: '';
    border-bottom: 3px solid white;
    transition: 0.2s ease-in;
    animation: grow-line 0.3s;
  }
</style>
